import React, { useRef, ReactInstance, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ReactToPrint from '../../ReactToPrint'
import { connect } from 'react-redux'
import SeaWayBill from '../../SeaWayBill'
import Header from '../../Header'
import Footer from '../../Footer'
import { setUIForwardAction } from '../../../actions'
import { AppState } from '../../../reducers'
import { UI } from '../../../constants/ui'
import './printSWB.less'
import multiplePrintoutsImg from '../../../assets/multiple-printouts.png'

class EmptyComponent extends React.Component {
  render() {
    return null
  }
}

const mapDispatchToProps = {
  setUIForward: setUIForwardAction,
}
const mapStateToProps = (state: AppState) => ({
  reservation: state.reservation.reservation,
  totalPagesCount: state.reservation.totalPagesCount,
  terminal: state.terminal.terminal,
})

type DispatchProps = typeof mapDispatchToProps
type StateProps = ReturnType<typeof mapStateToProps>
type Props = DispatchProps & StateProps

const Component: React.FC<Props> = ({ setUIForward, reservation, totalPagesCount, terminal }: Props) => {
  const { t } = useTranslation()
  const ele: ReactInstance = new EmptyComponent({})
  const seaWayBillRef = useRef<any>(null)
  const buttonRef = useRef<HTMLButtonElement | null>(null)
  const onCurrent = () => (seaWayBillRef.current ? seaWayBillRef.current : ele)
  const [isActivePrintButton, toggleActivityOfPrintButton] = useState(true)

  const onAfterSWBPrint = () => {
    if (totalPagesCount > 0) {
      setUIForward(UI.CHECKIN_DONE)
    } else {
      setUIForward(UI.MAIN)
    }
  }
  const onClickPrintButton = () => {
    toggleActivityOfPrintButton(false)
    buttonRef.current && buttonRef.current.click()
  }
  if (!reservation) {
    return null
  }
  return (
    <React.Fragment>
      <Header />
      <div className="printSWB">
        <div className="title" dangerouslySetInnerHTML={{ __html: t('twoDocumentsWillBePrinted') }}></div>
        <div className="block">
          <div className="text-block">
            <div className="text">{t('takeTheFirstPrintout')}</div>
            <div className="text">{t('pressButtonToPrintSecond')}</div>
          </div>
          <div className="image-block">
            <img className="image-printouts" src={multiplePrintoutsImg} alt="multiple printouts" />
          </div>
        </div>

        <div className="button">
          <button className="main-button next" onClick={onClickPrintButton} disabled={!isActivePrintButton}>
            {t('PRINT')}
          </button>
        </div>
        <div className="sea-way-template">
          <button className="fake-button-for-print" onClick={onAfterSWBPrint}></button>
          <ReactToPrint
            trigger={() => <button ref={buttonRef} className="hidden-button" />}
            content={onCurrent}
            copyStyles
            onAfterPrint={onAfterSWBPrint}
          />
          <div ref={seaWayBillRef}>
            <SeaWayBill reservation={reservation} terminal={terminal} />
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)
